import Tooltip from "@mui/material/Tooltip";
import "./styles.css";
import { capitalize } from "../../../utility/helpers";

const FeedbackTable = ({ data = [] }) => {
  if (!data || data.length === 0 || data === "N/A") {
    return (
      <div className="feedback-table-container" border={1}>
        <table
          className="feedback-table"
          style={{ height: "100%", minHeight: "394px" }}
        >
          <thead>
            <tr>
              <th>User</th>
              <th>Feedback Count</th>
              <th>Feedback Rate</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="3" style={{ textAlign: "center", padding: "20px" }}>
                No feedback data available
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="feedback-table-container">
      <table className="feedback-table">
        <thead>
          <tr>
            <th>User</th>
            <th className="feeback-count-header">Feedback Count</th>
            <th>Feedback Rate</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td className="user-email">
                {item.user_email ? (
                  <Tooltip title={item.user_email} disableInteractive arrow>
                    <span>
                      {item.first_name || item.last_name ? (
                        <>
                          {capitalize(item.first_name)}{" "}
                          {capitalize(item.last_name)}
                        </>
                      ) : (
                        item.user_email
                          .split("@")[0]
                          .split(/[._]/)
                          .map(
                            (part) =>
                              part.charAt(0).toUpperCase() +
                              part.slice(1).toLowerCase(),
                          )
                          .join(" ")
                      )}
                    </span>
                  </Tooltip>
                ) : (
                  "-"
                )}
              </td>
              <td className="feedback-count">{item.feedback_count ?? 0}</td>
              <td className="progress-cell">
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{
                      width: `${Math.min(item.feedback_rate || 0, 100)}%`,
                    }}
                  />
                </div>
                <span className="progress-label">
                  {Math.round(item.feedback_rate || 0)}%
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FeedbackTable;
